export const componentStyles = {

  rowStyle: {
    flex: "auto",
  },
  imageContainer: {
    position: "relative",
    width: "100%",
    height: "auto",
    textAlign: "center",
  },
  imageStyling: {
    display: "block",
    width: "80%",
    height: "auto",
    margin: "20px auto",
  },
  textStyle: {
    position: "absolute",
    top: "45%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "black",
    fontWeight: 500,
    fontSize: "1.2vw",
    padding: "10px",
    width: "50%",
    textAlign: "center",
    boxSizing: "border-box",
    maxWidth: "50%",
  },

  padding: {
    padding: "20px 40px",
    paddingLeft: "53px",
  },

  disabledButtonStyle: {
    backgroundColor: "#ddd",
    color: "white",
    marginLeft: "0px",
  },

  content: {
    display: "contents",
    paddingBottom: "20px",
  },

  spacingBottom: {
    paddingBottom: "0px",
  },

  startSectionDesign: {
    backgroundColor: "#dfe9f4",
    borderRadius: "50px",
    height: "70vh",
    width: "120vw",
  },

  logoPadding: {
    paddingLeft: "20px",
    '@media (max-width: 768px)': {
      paddingLeft: "0%",
      textAlign: "center",
    },
  },
  largeImage: {
    width: "50%",
    maxWidth: "50%",
    height: "auto",
    objectFit: "contain",
    '@media (max-width: 768px)': {
      maxWidth: "50%",
    },
  },

  buttonStyle: {
    backgroundColor: "#da93bd",
    color: "white",
    margin: "10px auto 0",
    width: "80%",
    height: "50px",
    borderRadius: "60px",
    display: "block",
    '@media (max-width: 768px)': {
      margin: "20px auto 0",
      width: "80%",
      maxWidth: "330px",
    },
  },
  buttonStyle2: {
    backgroundColor: "#4981ba",
    color: "white",
    margin: "0px 5px auto 0",
    width: "80%",
    height: "50px",
    borderRadius: "60px",
    display: "block",
    '@media (max-width: 768px)': {
      margin: "20px auto 0",
      width: "80%",
      maxWidth: "330px",
    },
  },

  pinkBox: {
    display: "flex",
    margin: "7px auto 0",
    width: "330px",
    height: "45px",
    borderRadius: "60px",
    border: "4px solid #da93bd",
    backgroundColor: "white",
    '@media (max-width: 768px)': {
      margin: "7px auto 0",
      width: "80%",
      maxWidth: "330px",
    },
  },

  halfBox: {
    flex: 1,
    height: "100%",
  },

  halfPink: {
    backgroundColor: "#da93bd",
    borderBottomRightRadius: "30px",
    borderTopRightRadius: "30px",
    borderBottomLeftRadius: "20px",
    borderTopLeftRadius: "20px",
  },
  versionTextUpdate: {
    float: "right",
    padding: '0px 10px 0px 10px',
    fontWeight: '600',
    fontSize: "10px",
  },

  textStyleParagraph: {
    fontWeight: 400,
    fontSize: "15px",
    marginLeft: "20px",
    marginTop: "10px",
    '@media (max-width: 768px)': {
      marginLeft: "0",
      textAlign: "center",
    },
  },
};